<template>
  <div class="confirmation-step text-center">
    <div class="mb-2">
      <div
        class="avatar bg-light-success rounded-circle mx-auto mb-2"
        style="width: 80px; height: 80px; display: flex; align-items: center; justify-content: center"
      >
        <feather-icon icon="CheckCircleIcon" size="40" class="text-success" />
      </div>
      <h2 class="mb-1">{{ title }}</h2>
      <p class="text-muted">{{ message }}</p>
    </div>

    <b-card v-if="showPaymentInfo" class="mb-2">
      <h5 class="mb-1">Prochaines étapes</h5>
      <p class="mb-0">
        Vous allez recevoir un email avec les instructions pour procéder au paiement.
        Le projet sera généré une fois le paiement confirmé.
      </p>
    </b-card>

    <b-button variant="primary" @click="handleClose">
      Fermer
    </b-button>
  </div>
</template>

<script>
import { BCard, BButton } from "bootstrap-vue";

export default {
  name: "QuoteValidationStepConfirmation",
  components: {
    BCard,
    BButton,
  },
  props: {
    title: {
      type: String,
      default: "Validation confirmée",
    },
    message: {
      type: String,
      default: "Votre décision a été enregistrée avec succès.",
    },
    showPaymentInfo: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const handleClose = () => {
      // Fermer la fenêtre ou rediriger
      window.close();
    };

    return {
      handleClose,
    };
  },
};
</script>

<style scoped>
.confirmation-step {
  max-width: 500px;
  margin: 0 auto;
  padding: 2rem 0;
}
</style>
